import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_device_event.js";
//#region src/bite_log_device_event_helper.ts
var bite_log_device_event_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(event) {
	switch (event) {
		case 50: return "app-update";
		case 8: return "apn-received";
		case 54: return "application-is-being-logout";
		case 38: return "application-is-being-terminated";
		case 30: return "battery-depleting";
		case 33: return "battery-state-change";
		case 32: return "bluetooth-state-change";
		case 21: return "bridge-eval-error";
		case 48: return "camera-initialization-error";
		case 3: return "config-change";
		case 29: return "crashlytics-crash";
		case 56: return "entered-menu";
		case 20: return "empty-js";
		case 26: return "error-sending-order";
		case 2: return "exit-menu-to-config-screen";
		case 51: return "failed-order-creation";
		case 16: return "failed-order-validation";
		case 43: return "failed-to-download-menu-assets";
		case 14: return "failed-to-enter-asam";
		case 15: return "failed-to-exit-asam";
		case 12: return "failed-to-start-webview";
		case 68: return "garcon-health-check-failed";
		case 64: return "garcon-js-crash";
		case 7: return "gcn-js-crash";
		case 9: return "gcn-js-error";
		case 49: return "jaws-error";
		case 53: return "jaws-license";
		case 62: return "kiosk-entered-maintenance-mode";
		case 63: return "kiosk-exited-maintenance-mode";
		case 71: return "kiosk-updated-maintenance-mode";
		case 1: return "low-battery";
		case 34: return "manual-app-restart";
		case 18: return "memory-warning";
		case 55: return "menu-cover-tapped";
		case 69: return "native-failure";
		case 59: return "native-log";
		case 72: return "native-touch-gesture-blocked";
		case 73: return "native-touch-gesture-ok";
		case 61: return "native-transaction-finished";
		case 60: return "native-transaction-started";
		case 28: return "no-notification-permissions";
		case 0: return "ok";
		case 31: return "push-received";
		case 6: return "reachability-none";
		case 5: return "reachability-ok";
		case 13: return "recovered-from-crash";
		case 19: return "reload-html";
		case 36: return "remote-test-print-error";
		case 35: return "remote-test-print-success";
		case 57: return "scale-data";
		case 58: return "scale-log";
		case 47: return "scanner-data";
		case 46: return "self-destruct-max-session-count-reached";
		case 41: return "self-destruct-no-kitchen-printer";
		case 40: return "self-destruct-no-payment";
		case 42: return "self-destruct-no-receipt-printer";
		case 52: return "session-ended";
		case 37: return "session-started";
		case 74: return "speed-test-results";
		case 39: return "start-fail";
		case 79: return "transaction-outbox-replay-success";
		case 66: return "vitrine-health-check-failed";
		case 67: return "vitrine-health-check-success";
		case 65: return "vitrine-js-crash";
		case 22: return "webview-did-commit-navigation";
		case 23: return "webview-did-terminate";
		case 24: return "webview-failed-provisional-navigation";
		case 25: return "webview-redirect-provisional-navigation";
		case 45: return "whitelist-test-failure";
		case 44: return "whitelist-test-success";
		case 70: return "vitrine-network-error";
		case 75: return "kiosk-ready";
		case 76: return "garcon-network-error";
	}
}
//#endregion
export { bite_log_device_event_helper_exports, name };

//# sourceMappingURL=bite_log_device_event_helper.js.map